import { Component } from "@angular/core"
import { EduComponent } from "../../utils/eduComponent"
import { UserService } from "../../services/user.service"
import { NotificationsService } from "angular2-notifications"
import Utils from "../../utils/utils"
import { redirectToError } from "../../utils/error-handling"
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router"
import { GTMService } from "../../services/gtm.service"
import { Title } from "@angular/platform-browser"
import { Location } from "@angular/common"
import { PBSLM_TITLE, STATIC_IMAGES } from "../../models/constants"
import { StudentAssignmentItem, StudentAssignments } from "../../models/studentAssignmentItem.model"
import { StudentService } from "../../services/student.service"

@Component({
    selector: "app-student-assignments",
    templateUrl: "./student-assignments.component.html",
    styleUrls: ["./student-assignments.component.scss"],
})
export class StudentAssignmentsComponent extends EduComponent {
    public assignmentCode: string = ""
    public assignments: StudentAssignments
    public activeAssignments = []
    public isLoadingMoreAssignments = false
    public checkSignURL = STATIC_IMAGES.STUDENT.check

    constructor(
        private userService: UserService,
        private studentService: StudentService,
        private route: ActivatedRoute,
        private notificationService: NotificationsService,
        private router: Router,
        private gtmService: GTMService,
        private titleService: Title,
        private location: Location
    ) {
        super()
        this.titleService.setTitle(PBSLM_TITLE)
        this.gtmService.resetDataLayer()
        this.gtmService.pushPageView()
        this.addSub(
            this.router.events.subscribe((e: any) => {
                if (e instanceof NavigationEnd) {
                    // We want this to work and reload data on onSameUrlNavigation
                    this.initializeData()
                }
            })
        )
    }

    private initializeData() {
        const data = this.route.snapshot.data.assignments
        if (!data) {
            this.assignments = new StudentAssignments([], null)
        } else if (data.error) {
            redirectToError(this.router, this.location, data.error.status)
        } else {
            this.assignments = data.assignments
        }
    }

    public isActive(code) {
        return this.activeAssignments.indexOf(code) > -1
    }

    public toggleActive(code) {
        const index = this.activeAssignments.indexOf(code)
        if (index > -1) {
            this.activeAssignments.splice(index, 1)
        } else {
            this.activeAssignments.push(code)
        }
    }

    public showMore() {
        if (!this.assignments.nextURL || this.isLoadingMoreAssignments) {
            return
        }
        this.isLoadingMoreAssignments = true
        this.studentService
            .loadMoreAssignments(this.assignments.nextURL)
            .subscribe((newAssignments: StudentAssignments) => {
                this.assignments.addFrom(newAssignments)
                this.isLoadingMoreAssignments = false
            })
    }

    public submitAssignmentsForm($event) {
        $event.preventDefault()
        this.userService.validateCode(this.assignmentCode).subscribe((data: any) => {
            if (data.url && data.url.length > 0) {
                window.location.href = data.url
            } else if (data.error) {
                this.notificationService.error("", data.error, Utils.alertConfiguration)
            }
        })
    }

    public startAssignment(assignment: StudentAssignmentItem) {
        if (
            !this.userService.isStudent() &&
            assignment.activity.teacherId === this.userService.getUserPK()
        ) {
            window.location.href = window.location.origin + assignment.activity.previewURL
        }
        const updateObj = {
            status: "started",
            student_name: " ",
        }

        this.userService.updateResult(assignment.id, updateObj).subscribe(
            (data: any) => {
                if (data?.location) {
                    window.location.href = data.location
                } else if (data?.data?.location) {
                    window.location.href = data.data.location
                } else {
                    window.location.href = assignment.studentResultURL
                }
            },
            (error) => {
                let message =
                    "An error occurred while starting the assignment. Please refresh and try again!"
                if (error.error && error.error.result && error.error.result.status) {
                    message = error.error.result.status
                }
                this.notificationService.error("Uh oh!", message, Utils.alertConfiguration)
            }
        )
    }
}
